import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.Step = React.createClass({
  onStepProgression: function() {
    if(this.props.currentStep.onSubmit) {
      this.props.currentStep.onSubmit(this.props.onStepProgression, this.props.onRequest, this.props.onRequestCompletion)
    }
  },

  onStepRetreat: function() {
    this.props.currentStep.onLeftNavButtonClick ? this.props.currentStep.onLeftNavButtonClick(this.props.onStepProgression) : this.props.onStepRetreat()
  },

  onModalExit: function() {
    var $jobModal = $('#job-modal')

    if (Job.Data.id !== null) {
      $jobModal.find('.close-modal-warning').velocity('slideUp').end()
                .find('.close').rmHidden()
      return
    }

    Job.PostingProgressActions.updateTracking({ exitType: 'modal_posting_blocked' })
    Job.PostingProgressActions.createPostingProgress()
    Job.Actions.resetData()
    this.setState({currentStep: JobWizardMobile.Steps[0]})
    $jobModal.modal('hide')
    $jobModal.find('.modal-stay').trigger('click') // hide this warning
    JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.Steps[0])
  },

  onSecondaryNavButtonClick: function() {
    this.props.currentStep.onSecondaryNavButtonClick ? this.props.currentStep.onSecondaryNavButtonClick() : null
  },

  componentWillEnter(callback) {
    const el = findDOMNode(this);
    TweenMax.fromTo(el, 0.3, {y: 100, opacity: 0}, {y: 0, opacity: 1, onComplete: callback});
  },

  navButtonLayout: function() {
    var buttonDefault = window.mobilecheck() === true ? 'upAndDownButton' : 'default'

    return this.props.currentStep.buttonLayout ? this.props.currentStep.buttonLayout() : buttonDefault
  },

  handleClick: function(e) {
    let text = $(e.target).parents('.form-group').last().find('h3').text()
    Job.PostingProgressActions.updateTracking({lastQuestion: text})
  },

  render: function() {
    const ComponentClass = this.props.currentStep.component;

    return (
      <div className="job-modal-step"> {/* extra div below needed by react */}
        <JobWizardMobile.Header/>
        <div className="modal-body job-form-body pb0" onClick={this.handleClick} onInput={this.handleClick}>
          <ComponentClass
            onStepProgression={this.onStepProgression}
            onRequest={this.props.onRequest}
            onRequestCompletion={this.props.onRequestCompletion}
          />
        </div>
        <div className="modal-footer pt0">
          <JobWizardMobile.NavigationButtons
            navButtonLayout={this.navButtonLayout()}
            buttons={this.props.currentStep.navigation}
            onStepProgression={this.onStepProgression}
            onStepRetreat={this.onStepRetreat}
            onSecondaryNavButtonClick={this.onSecondaryNavButtonClick}
            onModalExit={this.onModalExit}
          />
        </div>
      </div>
    )
  }
})
